import {ApolloClient, ApolloQueryResult, gql} from '@apollo/client';
import {errorResponse, NetworkResult, successResponse} from './NetworkResult';
import {Me} from '../Models/Me';
import {Distance} from '../Domain/Distance';
import {Weight} from '../Domain/Weight';

export class MeService {
    constructor(private client: ApolloClient<any>) {}

    public async get(): Promise<NetworkResult<Me>> {
        try {
            const apolloQueryResult = await this.client.query({
                query: gql`
                    query {
                        me {
                            id
                            email
                            strava_connected
                            crew_ical_url
                            is_confirmed
                            is_beta
                            subscriptions {
                                id
                                crew_id
                                status
                                expires_at_iso8601
                            }
                            snippet_collections {
                                id
                                name
                            }
                            snippet_users {
                                id
                                display_name
                            }
                            length
                            weight
                        }
                    }
                `,
            });
            return this.toResponse(apolloQueryResult);
        } catch (e) {
            console.error(e);
            return errorResponse();
        }
    }

    private toResponse(apolloQueryResult: ApolloQueryResult<any>): NetworkResult<Me> {
        if (apolloQueryResult.errors) {
            return errorResponse();
        }

        return successResponse({
            id: apolloQueryResult.data.me.id,
            email: apolloQueryResult.data.me.email,
            stravaConnected: apolloQueryResult.data.me.strava_connected,
            crewIcalUrl: apolloQueryResult.data.me.crew_ical_url,
            isConfirmed: apolloQueryResult.data.me.is_confirmed,
            isBeta: apolloQueryResult.data.me.is_beta,
            isAdvanced: apolloQueryResult.data.me.is_advanced,
            subscriptions: apolloQueryResult.data.me.subscriptions.map((subscription: any) => {
                return {
                    id: subscription.id,
                    crewId: subscription.crew_id,
                    status: subscription.status,
                    expirationDate: subscription.expires_at,
                };
            }),
            snippetCollections: apolloQueryResult.data.me.snippet_collections.map((snippetCollection: any) => {
                return {
                    id: snippetCollection.id,
                    name: snippetCollection.name,
                };
            }),
            snippetUsers: apolloQueryResult.data.me.snippet_users.map((snippetUser: any) => {
                return {
                    id: snippetUser.id,
                    displayName: snippetUser.display_name,
                };
            }),
            length: Distance.fromCentimeters(apolloQueryResult.data.me.length),
            weight: Weight.fromKilograms(apolloQueryResult.data.me.weight),
        });
    }
}
